import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core';
import { LhStorageService } from '@hssa-itasia/ngx-util-core';
import { AppService } from '../app.service';

@Component({
  selector: 'custom-hazid-tab-one',
  styles: [
    `
      .hazcard {
        margin-bottom: 10px;
        padding: 10px;
      }
      mat-tab-body {
        padding: 20px 5px !important;
      }
      .ion_seg {
        font-size: 16px;
      }
      .segment_text {
        text-transform: none;
      }
      .haz_housekeeping {
        font-size: 12px;
        font-weight: bold;
      }
      .slno_col {
        margin-left: 26px;
        padding-top: 15px;
        margin-right: -5px;
      }
      .slno_label {
        font-size: 12px;
        font-weight: bold;
        color: #000;
      }
      .housekeeping_col_div {
        margin-left: -45px;
      }
      .checkbox_hazid {
        padding: 2px;
        background-color: #6a6a6a;
        color: white;
        border-top-right-radius: 100px;
        border-bottom-right-radius: 100px;
        width: 129px;
        height: 31px;
        border-bottom-left-radius: 100px;
        border-top-left-radius: 100px;
      }
      .HAZID_col {
        padding: 6px;
        text-align: left;
      }
      .HAZID_col_label {
        margin-left: 5px;
        color: #ffff;
      }
      .house_col_div {
        margin-left: 10px;
      }
      .hazid_health_tab_container formly-field-mat-multicheckbox {
        /*display: grid;*/
        grid-template-columns: auto;
        grid-gap: 5px;
        /* margin-top:-28px; */
      }
      .hazid_safety_tab_container formly-field-mat-multicheckbox {
        /*display: grid;*/
        grid-template-areas:
          's1 s9 s14'
          's2 s10 s15'
          's3 s11 s16'
          's4 s12 s17'
          's5 s13 s18'
          's6 . s19'
          's7 . .'
          's8 . .';
        grid-gap: 5px;
        /* margin-top:-28px; */
      }
      .hazid_env_tab_container formly-field-mat-multicheckbox {
        /*display: grid;*/
        grid-template-columns: auto;
        grid-gap: 5px;
        /* margin-top:-28px; */
      }
      .hazid_hk_tab_container formly-field-mat-multicheckbox {
        /* display: grid;*/
        grid-template-columns: auto;
        grid-gap: 5px;
        /* margin-top:-28px; */
      }
      .hazid_ind_tab_container formly-field-mat-multicheckbox {
        /*display: grid;*/
        grid-template-columns: auto;
        grid-gap: 5px;
        /* margin-top:-28px; */
      }
      .hazcard_no_shadow {
        box-shadow: 0px 3px 6px #00000029;
        margin: 0px;
        border: none;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
      }
      .mt-20 {
        margin-top: 20px;
      }
      .titletext {
        padding: 10px 0;
      }
    `,
  ],
  template: `
    <ion-row *ngIf="to.title" class="title-text">
      <ion-label class="titletext"> {{ to.title | translate }}</ion-label>
    </ion-row>
    <ion-card
      *ngIf="!to.withoutCard"
      [ngClass]="{
        'hazcard_no_shadow ion-no-margin': vpc_name == 'VPC',
        'hazcard ion-no-margin': vpc_name != 'VPC',
      }"
    >
      <relates-to-tabs (relatesToTab)="updateTabs($event)">
        <relates-to-tab
          tabTitle="{{ tab.props.label }}"
          *ngFor="let tab of field.fieldGroup; let i = index; let last = last"
          id="{{ tab.props.label }}"
        >
          <formly-field [field]="tab"></formly-field>
        </relates-to-tab>
      </relates-to-tabs>
    </ion-card>
    <mat-tab-group *ngIf="to.withoutCard" class="mt-20" [selectedIndex]="selectedIndex">
      <mat-tab
        *ngFor="let tab of field.fieldGroup; let i = index; let last = last"
        id="{{ tab.props.label }}"
      >
        <ng-template mat-tab-label>
          <span>{{ tab.props.label }}</span>
        </ng-template>
        <formly-field [field]="tab"></formly-field>
      </mat-tab>
    </mat-tab-group>
  `,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HazidTabOneFormlyType extends FieldWrapper {
  hazSelectedImages: any[] = [];
  vpc_name: any;
  selectedSegment = 'health';
  selectedIndex: number | null = null;
  constructor(
    private appService: AppService,
    private lhStorage: LhStorageService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }
  async ngOnInit() {
    this.vpc_name = this.to.from;
    this.hazSelectedImages = this.appService.hazImageData;
  }
  async ngAfterViewInit() {
    // console.log('custom-hazid-tab-one wrapper initialized for key:', this.field.key,Date.now());
    const editObs: any = await this.lhStorage.get('editObservation');
    if (editObs?.currentObservationInfo) this.setSelectedSegmentBasedOnObservation(editObs);
    else this.selectedIndex = 0;
    this.cdr.detectChanges();
  }
  private async setSelectedSegmentBasedOnObservation(editObs: any) {
    // console.log("editObs");
    let relatesTo = editObs.currentObservationInfo?.relatesTo || [];
    // console.log("observation=",editObs.currentObservationInfo);
    // console.log("relatesTo=",relatesTo);
    const hazType = editObs.currentObservationInfo?.hazType;

    if (this.to?.from === 'VPC') {
      const hazCategory = relatesTo[0]?.haz_category?.toLowerCase();
      if (['health', 'safety', 'environment'].includes(hazCategory)) {
        this.selectedSegment = hazCategory;
      }
    }

    if (
      this.to?.from === 'HAZ' &&
      hazType === 'HAZID' &&
      this.field.key === 'custom_relates_to_haz'
    ) {
      let hazRelatesTo = editObs.currentObservationInfo?.relates_to;
      const hazCategory = hazRelatesTo[0]?.haz_category.toLowerCase();
      this.selectedSegment = hazCategory.charAt(0).toUpperCase() + hazCategory.slice(1);
      //console.log("selectedSegment=",this.selectedSegment);
      this.appService.updateBogTourIseeRelatesTo(this.selectedSegment);
    } else if (
      this.to?.from === 'HAZ' &&
      hazType === 'HOUSEKEEPING' &&
      this.field.key === 'custom_relates_to_hk'
    ) {
      let hazRelatesTo = editObs.currentObservationInfo?.relates_to;
      const type = hazRelatesTo[0]?.type?.toLowerCase();
      let hazSegment = type === 'facility' ? 'Facilities' : 'Industrial areas';
      this.selectedSegment = hazSegment;
      this.appService.updateBogTourIseeRelatesTo(this.selectedSegment);
    }
    // 🔥 Always use lower case comparison

    this.selectedIndex = this.field.fieldGroup.findIndex(
      (tab) => tab.props.label?.toLowerCase() === this.selectedSegment.toLowerCase()
    );
    if (this.selectedIndex === -1) {
      this.selectedIndex = 0;
    }
    //console.log("selectedIndex=",this.selectedIndex);
  }

  isValid(field: FormlyFieldConfig): boolean {
    if (field.key) {
      return field.formControl.valid;
    }

    return field.fieldGroup ? field.fieldGroup.every((f) => this.isValid(f)) : true;
  }

  hazSegmentChanged(event: any) {
    // console.log('event:',event);
    if (this.selectedSegment === 'health') {
      //console.log('event health:',event);
    }
    if (this.selectedSegment === 'safety') {
      //console.log('event safety:',event);
    }
    if (this.selectedSegment === 'environment') {
      //console.log('event environment:',event);
    }
  }
  updateTabs(event) {
    // console.log("event 170=",event);
    // console.log("this.formControl=",this.formControl);
    this.appService.updateSelectedObsTabsRelatesTo(event.title);
    this.formControl.patchValue(event);
    this.formControl.markAsTouched();
  }
}
